import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { httpOptions } from "./headers";


@Injectable({
  providedIn: 'root'
})
export class ApiConfigurationService {

  private configurationUrl = environment.configurationUrl;
  private parameterUrl = environment.parameterUrl;
  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'Basic ' + btoa('estimator:!Estimator')
    })
  };

  

  constructor(private http: HttpClient) { }

  getConfiguration(): Observable<any> {
    return this.http.get<any>(this.configurationUrl,httpOptions);
  }

  getParameters(): Observable<any> {
    return this.http.get<any>(this.parameterUrl,httpOptions);
  }

}
